import axios from "axios";
import authHeader from "./auth-header";
import { API_URL } from "./constants";

class ExtraStatusService {
  fetchExtraStatus(storeId = "") {
    return axios.get(API_URL + `extra-status/fetch-by-store-id/${storeId}`, {
      headers: authHeader(),
    });
  }
  addExtraStatus(data) {
    return axios.post(API_URL + `extra-status/set-extra-status`, data, {
      headers: authHeader(),
    });
  }
  removeExtraStatus(recordId, extraStatusId) {
    return axios.delete(
      API_URL + `extra-status/remove-extra-status/${recordId}/${extraStatusId}`,
      {
        headers: authHeader(),
      }
    );
  }
}

export default new ExtraStatusService();
